<template>
  <div>
    <section class="hero is-primary">
      <div class="hero-body">
        <div class="container nav-padding-fix">
          <div class="level">
            <div>
              <h1 class="title">
                Taxi St. Job
              </h1>
              <h2 class="subtitle">
                Administratie systeem
              </h2>
            </div>
            <div class="level-right">
              <div class="dropdown is-right is-hoverable">
                <div class="dropdown-trigger">
                  <button class="button" aria-haspopup="true" aria-controls="dropdown-menu">
                    <span class="capitalize">{{user.firstName}} {{user.lastName}}</span>
                    <span class="icon is-small">
                      <i class="fa fa-angle-down" aria-hidden="true"></i>
                    </span>
                  </button>
                </div>
                <div class="dropdown-menu" id="dropdown-menu" role="menu">
                  <div class="dropdown-content">
                    <router-link active-class="active" :to="{ name: 'settings.general' }" class="dropdown-item">
                      Instellingen
                    </router-link exact>
                    <hr class="dropdown-divider">
                    <a class="dropdown-item" @click="logout">
                      <span class="icon is-small is-left">
                        <i class="fa fa-lock" aria-hidden="true"></i>
                      </span>
                      Uitloggen
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="hero-foot">
        <div class="container">
          <nav class="tabs is-boxed">
            <ul>
              <!-- <router-link :to="{ name: 'overview' }" tag="li"><a>Overzicht</a></router-link>
              <router-link :to="{ name: 'creditcard.processing' }" tag="li"><a>Creditcardslips</a></router-link> -->
              <router-link :to="{ name: 'receipts.processing' }" tag="li"><a>Bonnen</a></router-link>
              <router-link :to="{ name: 'invoices.confirmation' }" tag="li"><a>Facturen</a></router-link>
              <router-link :to="{ name: 'crediteuren' }" tag="li"><a>Crediteuren</a></router-link>
              <router-link :to="{ name: 'debiteuren' }" tag="li"><a>Debiteuren</a></router-link>
              <router-link :to="{ name: 'settings.general' }" tag="li"><a>Instellingen</a></router-link>
            </ul>
          </nav>
        </div>
      </div>
    </section>

    <router-view></router-view>

    <footer class="footer spacing-top-50 has-text-left">
      <div class="container">
        <span class="tag is-primary">Web client: {{clientVersion}}</span>
        <span class="tag is-info">API: {{apiVersion}}</span>
      </div>
    </footer>
  </div>
</template>

<script>
import pkg from '../../package.json'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      user: 'userDetails',
      apiVersion: 'apiVersion'
    })
  },
  data () {
    return {
      clientVersion: pkg.version
    }
  },
  async created () {
    try {
      await this.$store.dispatch('getUserDetails')
      await this.$store.dispatch('getApiVersion')
      await this.$store.dispatch('testAccountViewConnection')
    } catch (error) {
      this.$snackbar.open({
        type: 'is-danger',
        message: 'Er ging iets fout tijdens het ophalen van de gebruikers gegevens.'
      })
    }

    setInterval(async () => {
      await this.$store.dispatch('checkHealthApi')
    }, 10 * 1000)
  },
  methods: {
    logout () {
      this.$store.dispatch('logout')
      this.$router.push({ name: 'login' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard.vue